import { useRef } from 'react';
import useSWR from 'swr';
import api from 'utils/api';
import { searchUrl } from 'utils/searchScope';

// Resolve once per query/scope; subsequent pages keep both original and correction.
export default function useAssistedSearch(scope, query, start, rows, autoCorrect = true) {
  const resolved = useRef(null);
  const identity = JSON.stringify([scope, query, autoCorrect]);
  const currentIdentity = useRef(identity);
  currentIdentity.current = identity;
  const pinned = start > 0 && resolved.current?.identity === identity;
  const pageQuery = pinned ? resolved.current.query : query;
  const key = scope === null ? null : searchUrl('search', scope, {
    query, start, rows, autoCorrect,
    ...(pinned ? { correctionQuery: pageQuery } : {}),
  });
  const result = useSWR(key, async () => {
    const response = await api.get(key);
    if (currentIdentity.current === identity) {
      resolved.current = { identity, query: response.effectiveQuery ?? pageQuery };
    }
    return response;
  }, { shouldRetryOnError: false, revalidateOnFocus: false });
  const effectiveQuery = result.data?.effectiveQuery ?? pageQuery;
  return {
    ...result,
    data: result.data && {
      ...result.data, originalQuery: query, effectiveQuery,
      corrected: effectiveQuery !== query,
    },
  };
}
